import React from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_container__2pRR5 {\n  /* border: 1px solid yellow; */\n  position: relative;\n}\n\n.styles_innerParent__2NGpN {\n  /* border: 1px solid blue; */\n  overflow: hidden;\n  white-space: nowrap;\n\n  white-space: nowrap;\n  position: relative;\n}\n\n.styles_ellipsis__3lBvI {\n  right: 0px;\n  top: 1px;\n  position: absolute;\n  width: 12px;\n  background-color: #ffffff;\n}\n\n.styles_child__2NOY6 {\n  /* border: 1px red dashed ; */\n  display: inline-block;\n}\n";
var styles = { "container": "styles_container__2pRR5", "innerParent": "styles_innerParent__2NGpN", "ellipsis": "styles_ellipsis__3lBvI", "child": "styles_child__2NOY6" };
styleInject(css);

var BUMPER_PERCENT = 0.25;
var Scroll = /** @class */function (_super) {
    __extends(Scroll, _super);
    function Scroll(props) {
        var _this = _super.call(this, props) || this;
        _this.disabled = false;
        _this.widthDiff = 0;
        _this.parentWidth = 0;
        _this.childWidth = 0;
        _this.offset = 0;
        _this.childPosition = 0;
        _this.childTarget = 0;
        _this.bumper = 0;
        _this.raf = null;
        _this.state = {
            ellipsis: false
        };
        _this.getSizes = function () {
            _this.parentWidth = _this.getWidth(_this.parent.current);
            _this.childWidth = _this.getWidth(_this.child.current);
            _this.widthDiff = _this.childWidth - _this.parentWidth;
            _this.bumper = _this.parentWidth * BUMPER_PERCENT;
        };
        _this.onMouseOut = function (event) {
            if (_this.disabled) return;
            _this.resetPosition();
        };
        _this.onMouseMove = function (event) {
            // If child already fits, we don't need to do anything
            if (_this.disabled) return;
            _this.getSizes();
            // get the local X possition within the parent
            var parent = _this.parent.current;
            var parentRect = parent.getBoundingClientRect();
            var x = event.clientX - parentRect.left; // x position within the element.
            // Calculate offset; what local X maps to within bigger child. For ex:
            // if child is 200px wide, and parent is 50, then x of 25 should be 100 in child.
            _this.offset = _this.mapRange(x, _this.bumper, _this.parentWidth - _this.bumper, 0, _this.widthDiff);
            // Make sure the offset is within bounds
            if (_this.offset < 0) _this.offset = 0;
            if (_this.offset > _this.widthDiff) _this.offset = _this.widthDiff;
            // Start child sliding animation to the target offset
            _this.childTarget = -1 * _this.offset;
            _this.startSlide();
        };
        // Moves child back to 0
        _this.resetPosition = function () {
            _this.childTarget = 0;
            _this.startSlide();
        };
        _this.startSlide = function () {
            // If there's already an animation in progress, don't do anything
            if (!_this.raf) {
                _this.raf = requestAnimationFrame(_this.slide);
            }
        };
        _this.slide = function () {
            var delta = _this.childTarget - _this.childPosition;
            // each "frame" we move by SLIDE_SPEED percent of the distance
            // TODO: conver this to time based with animation curves
            _this.childPosition = _this.childPosition + delta * _this.props.speed;
            _this.setChildPosition(_this.childPosition);
            // end animation if we're less than 1px away
            if (Math.abs(delta) < 1) {
                cancelAnimationFrame(_this.raf);
                _this.raf = null;
                return;
            }
            // Get next "frame"
            requestAnimationFrame(_this.slide);
        };
        _this.container = React.createRef();
        _this.parent = React.createRef();
        _this.child = React.createRef();
        return _this;
    }
    Scroll.prototype.componentDidMount = function () {
        this.getSizes();
        if (this.widthDiff > 0) {
            this.setState({ showEllipsis: true });
        }
        if (this.widthDiff <= 0) {
            this.disabled = true;
        }
    };
    Scroll.prototype.getWidth = function (el) {
        if (!el) throw new Error('Element is null');
        return el.offsetWidth;
    };
    Scroll.prototype.setChildPosition = function (x) {
        var y = 0;
        var style = "\n      -ms-transform: translate(" + x + "px, " + y + "px);]\n      -webkit-transform: translate(" + x + "px, " + y + "px);\n      transform: translate(" + x + "px, " + y + "px);\n    ";
        this.child.current.setAttribute('style', style);
    };
    // map value X in range a->b to rage c->d
    Scroll.prototype.mapRange = function (x, a, b, c, d) {
        var y = (x - a) * ((d - c) / (b - a)) + c;
        return y;
    };
    Scroll.prototype.render = function () {
        var parentStyles = {
            lineHeight: '20px',
            height: '20px'
        };
        var height = this.props.height;
        if (height) {
            parentStyles.lineHeight = height;
            parentStyles.height = height;
        }
        return React.createElement(
            'div',
            { id: 'container', className: styles.container, onMouseLeave: this.onMouseOut, ref: this.container },
            React.createElement(
                'div',
                { id: 'scroverflow-inner-parent', className: styles.innerParent, style: parentStyles, ref: this.parent, onMouseMove: this.onMouseMove },
                React.createElement(
                    'div',
                    { id: 'scroverflow-child', className: styles.child, ref: this.child },
                    this.props.children
                )
            )
        );
    };
    Scroll.defaultProps = {
        speed: 0.05
    };
    return Scroll;
}(React.Component);

export default Scroll;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 366
// module chunks = 0